import { render, staticRenderFns } from "./PlateKlineModal.vue?vue&type=template&id=113a4a5c&scoped=true"
import script from "./PlateKlineModal.vue?vue&type=script&lang=js"
export * from "./PlateKlineModal.vue?vue&type=script&lang=js"
import style0 from "./PlateKlineModal.vue?vue&type=style&index=0&id=113a4a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113a4a5c",
  null
  
)

export default component.exports